import React from 'react';
import PropTypes from 'prop-types';
import Backdrop from '@material-ui/core/Backdrop';
import styled from 'styled-components';
import { useTranslation, Trans } from 'react-i18next';

import { FETCH_ASSETS_URL } from 'appenv';

import CloseIcon from '@material-ui/icons/Close';

const acceptCallIcon = `${FETCH_ASSETS_URL}/assets/accept_call.png`;
const hangUpCallIcon = `${FETCH_ASSETS_URL}/assets/hangup_call.png`;

const Container = styled.div`
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  display: flex;
  height: 100%;
`;

const ImgButton = styled.img`
  cursor: pointer;
`;

const CallingStatusContainer = styled.div`
  text-align: center;
  color: #FFF;
`;

const FlexContainer = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  color: #FFF;

  & > div {
    margin: 0 100px;
    white-space: pre;
  }
`;

const CloseBtnContainer = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
  color: #FFF;
`;

const LinkContainer = styled.div`
  position: absolute;
  top: 30%;
  text-align: center;
  width: 100%;
  padding: 25px;

  & > a {
    color: #FFF;
  }
`;

const CustomUrlText = styled.div`
  color: #FFF;
  text-decoration: underline;
  cursor: pointer;
`;

const RtcChatMobile = ({
  rtcCallingInfo,
  rtcCallingStatus,
  decline,
  pickUp,
  cancel,
  onVideoCallUrlClick,
  close,
  waitingTimeLeft,
}) => {
  const { t } = useTranslation();

  const renderCallerName = () => {
    switch (rtcCallingStatus) {
      case 'waiting_for_response':
        return (
          <>
            <Trans
              i18nKey="call.waiting_response_mobile"
              values={{ name: rtcCallingInfo.name }}
              // eslint-disable-next-line jsx-a11y/heading-has-content
              components={{ b: <h2 /> }}
              defaults="<b>Waiting for response from</b> <b>%{name}</b>"
            />
            {
              Boolean(waitingTimeLeft) && (
                <Trans
                  i18nKey="call.waiting_response_mobile_timer"
                  values={{ times: waitingTimeLeft / 1000 }}
                  components={{ b: <div /> }}
                  defaults="<b>In %{times} seconds</b>"
                />
              )
            }
          </>
        );
      case 'being_called':
        return (
          <Trans
            i18nKey="call.invites_you_mobile"
            values={{ name: rtcCallingInfo.name }}
            // eslint-disable-next-line jsx-a11y/heading-has-content
            components={{ b: <h2 /> }}
            defaults="<b>%{name}</b> <b>invites you to video call</b>"
          />
        );
      default:
        return null;
    }
  };

  return (
    <Backdrop
      open
      style={{ zIndex: 10000, backgroundColor: 'rgba(0, 0, 0, 0.8)' }}
    >
      <Container>
        {
          ['caller_connecting', 'callee_connecting'].includes(rtcCallingStatus) && (
            <CloseBtnContainer onClick={close}>
              <CloseIcon />
            </CloseBtnContainer>
          )
        }
        <CallingStatusContainer>
          {renderCallerName()}
        </CallingStatusContainer>
        {
          rtcCallingStatus === 'being_called' && (
            <FlexContainer>
              <div role="button">
                <ImgButton src={hangUpCallIcon} alt="Hang Up" onClick={decline} />
                <p>{t('call.hang_up', 'Hang Up')}</p>
              </div>
              <div role="button">
                <ImgButton src={acceptCallIcon} alt="Accept" onClick={pickUp} />
                <p>{t('call.accept', 'Accept')}</p>
              </div>
            </FlexContainer>
          )
        }
        {
          rtcCallingStatus === 'waiting_for_response' && (
            <FlexContainer>
              <div role="button">
                <ImgButton src={hangUpCallIcon} alt="Hang Up" onClick={cancel} />
                <p>{t('call.hang_up', 'Hang Up')}</p>
              </div>
            </FlexContainer>
          )
        }
        {
          ['caller_connecting', 'callee_connecting'].includes(rtcCallingStatus) && (
            <LinkContainer>
              <CustomUrlText onClick={onVideoCallUrlClick}>{t('call.open_video_call')}</CustomUrlText>
            </LinkContainer>
          )
        }
      </Container>
    </Backdrop>
  );
};

RtcChatMobile.propTypes = {
  rtcCallingInfo: PropTypes.shape().isRequired,
  rtcCallingStatus: PropTypes.string.isRequired,
  decline: PropTypes.func.isRequired,
  pickUp: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  onVideoCallUrlClick: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  waitingTimeLeft: PropTypes.number.isRequired,
};

export default RtcChatMobile;
